import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-4 pb-6 sm:pt-12 sm:pb-20 items-center justify-center bg-bg-main overflow-hidden" data-id="element-136">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.15) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-137"></div>

      {/* Attention Badge */}
      <div className="relative bg-badge-red/10 border border-badge-red/20 text-badge-red font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-3 sm:mb-6 flex items-center gap-1.5 sm:gap-2" data-id="element-138">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-badge-red animate-pulse-composited" data-id="element-139"></span>
        <span className="hidden sm:inline" data-id="element-140">
          ATTENZIONE: INSEGNANTI DI SOSTEGNO E CURRICOLARI STANCHE DI PASSARE LE
          NOTTI A CREARE MATERIALI PER L'INCLUSIONE
        </span>
        <span className="sm:hidden" data-id="element-141">
          ATTENZIONE: INSEGNANTI DI SOSTEGNO E CURRICOLARI
        </span>
      </div>

      {/* Main headline */}
      <h1 className="relative font-black text-text-main max-w-5xl sm:text-5xl md:text-6xl sm:leading-[1.1] mb-2 sm:mb-6 tracking-tight text-[26px]" data-id="element-142">
        Risolvi l'intera{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-orange-400" data-id="element-143">
          programmazione inclusiva
        </span>{' '}
        in soli 5 minuti.
      </h1>

      {/* Subheadline */}
      <p className="relative text-text-sec text-[13px] sm:text-xl font-medium leading-relaxed mb-3 sm:mb-8 max-w-3xl mx-auto sm:bg-bg-alt sm:border sm:border-white/10 sm:border-l-4 sm:border-l-primary sm:px-8 sm:py-5 sm:rounded-r-xl sm:text-left" data-id="element-144">
        Il primo Sistema{' '}
        <span className="text-orange-400 font-bold" data-id="element-145">"Apri e Insegna"</span> con
        attività visive, strumenti per il PEI e laboratori pronti, dalla Scuola
        dell'Infanzia alla Primaria.{' '}
        <span className="hidden sm:inline text-text-main font-semibold" data-id="element-146">
          Recupera i tuoi weekend e trasforma la tua classe in un ambiente dove
          ogni bambino può fiorire.
        </span>
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[260px] sm:max-w-[480px] md:max-w-[560px] mx-auto mb-2 sm:mb-8" data-id="element-147">
        <div className="absolute inset-0 rounded-full pointer-events-none" style={{
        background: 'radial-gradient(circle, rgba(234,88,12,0.15) 0%, transparent 70%)'
      }} aria-hidden="true" data-id="element-148"></div>
        <img src="https://cdn.magicpatterns.com/uploads/7AfEzv4GHFCHYjUgGCNrGR/Diseno-sin-titulo-_43_.webp" alt="KIT PROFESSIONALE INCLUSIONE 360° — Archivio Didattico Completo" className="relative w-full h-auto object-contain" width={420} height={420} sizes="(max-width: 640px) 220px, (max-width: 768px) 360px, 420px" fetchPriority="high" data-id="element-149" />
      </div>

      {/* Stars + Urgency */}
      <div className="relative flex flex-col items-center gap-1.5 sm:gap-2 mb-3 sm:mb-6" data-id="element-150">
        <div className="flex items-center gap-2" data-id="element-151">
          <span className="text-secondary text-sm sm:text-lg" data-id="element-152">⭐⭐⭐⭐⭐</span>
          <span className="text-text-sec text-xs sm:text-base font-medium" data-id="element-153">
            4.9/5 (+1.800 Recensioni Verificate)
          </span>
        </div>
        <span className="text-secondary font-bold text-xs sm:text-sm bg-secondary/10 px-3 py-1 rounded-full border border-secondary/20" data-id="element-154">
          🔥 124 insegnanti hanno scelto questo Kit oggi
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-base sm:text-2xl px-6 sm:px-12 py-3.5 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-colors inline-block mb-2 sm:mb-4 w-full sm:w-auto max-w-xl text-gray-900 shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/10" data-id="element-155">
        🚀 SÌ! VOGLIO RECUPERARE IL MIO TEMPO
      </a>

      {/* Trust badges */}
      <p className="relative text-text-sec text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" data-id="element-156">
        <span data-id="element-157">⚡ Accesso Immediato</span>
        <span data-id="element-158">•</span>
        <span data-id="element-159">🛡️ Garanzia 7 Giorni</span>
        <span data-id="element-160">•</span>
        <span data-id="element-161">💳 Pagamento Unico</span>
      </p>
    </section>;
}